var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "../../lib/utils.js";
var Checkbox = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx(CheckboxPrimitive.Root, __assign({ ref: ref, className: cn("w-4 h-4 flex-shrink-0 rounded-sm border border-[#A09D9B] dark:border-muted-foreground bg-[hsl(var(--background))] transition-all duration-200 ease-in-out", "hover:border-[hsl(var(--primary-hover-dark))] hover:bg-[hsl(var(--primary-hover-dark))]", "data-[state=checked]:border-[hsl(var(--primary-pressed-dark))] data-[state=checked]:bg-[hsl(var(--primary-pressed-dark))] data-[state=checked]:text-[hsl(var(--primary-foreground))]", "dark:data-[state=checked]:border-[hsl(var(--primary))] dark:data-[state=checked]:bg-[hsl(var(--primary))] dark:data-[state=checked]:text-[hsl(var(--primary-foreground))]", "disabled:border-[hsl(var(--muted))] disabled:bg-[hsl(var(--muted))] disabled:opacity-50 disabled:cursor-not-allowed", "peer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", className) }, props, { children: _jsx(CheckboxPrimitive.Indicator, { className: "flex items-center justify-center", children: _jsx(Check, { className: "h-4 w-4 text-[hsl(var(--checkbox-text))] dark:text-[hsl(var(--primary-foreground))]" }) }) })));
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
export { Checkbox };
